import cs from "classnames";
import React from "react";
import {Box} from "@chakra-ui/react";

export const Card = ({children}: {children: React.ReactNode}) => {
  return <Box backgroundColor={"white"} rounded={"base"} overflow={"hidden"} shadow={"base"} padding={[5]}>
    {children}
  </Box>
}

export type CardTitleProps = {
  children: React.ReactNode
  className?: string
  justify?: boolean
}
export const CardHead = ({justify, className, children}: CardTitleProps) => {

  return <div
    className={cs(
      "flex",
      justify && "justify-between",
      "items-center",
      "text-xl font-medium",
      className
    )}>
    {children}
  </div>
}


export type CardContentProps = {
  children: React.ReactNode
  className?: string
}

export const CardContent = ({className, children}: CardContentProps) => {
  return <div className={cs(
    "text-gray-700",
    className
  )}>
    {children}
  </div>
}
